import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

type DeleteConfirmationModalProps = {
	readonly isOpen: boolean;
	readonly itemName: string;
	readonly onConfirm: () => void;
	readonly onCancel: () => void;
	readonly entityType?: string;
};

export const DeleteConfirmationModal = ({
	isOpen,
	itemName,
	onConfirm,
	onCancel,
	entityType = "item",
}: DeleteConfirmationModalProps) => {
	if (!isOpen) return null;

	return (
		<TraxModal
			cancelText={"Cancel"}
			confirmText={"Yes, Delete"}
			confirmVariant={"primary"}
			onCancel={onCancel}
			onClose={onCancel}
			onConfirm={onConfirm}
			title={"Confirm Deletion"}
			type={"confirmation"}
		>
			Are you sure you want to remove &quot;{itemName}&quot; from your saved{" "}
			{entityType}?
		</TraxModal>
	);
};
